export enum BatchTriggeredBy{
    Timer,
    BatchLength,
    Flush,
    ActivateLength,
    DirectHit,
    DirectActivate
  }
